import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertPermissionRequest } from './types/upsert-permission-request.type';

/**
 * Creates or updates a permission.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param body - The permission payload (omit `uid` to create).
 * @returns OperationResultWithData wrapping the uid of the upserted permission.
 */
export const upsertPermission = async (instance: KyInstance, body: UpsertPermissionRequest) => {
  try {
    return await instance
      .post<OperationResultWithData<string>>(Uri.permissions.base, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
